var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIr = function SvgIr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M15.898 8.87h-1.57c.013.172.02.346.02.521 0 1.161-.29 2.286-.796 3.087-.156.247-.418.596-.77.831V8.87h-1.565v4.44c-.35-.235-.613-.584-.769-.83-.506-.802-.796-1.927-.796-3.088 0-.175.008-.349.02-.521h-1.57c-.01.171-.015.345-.015.521 0 3.219 1.719 5.74 3.913 5.74s3.913-2.521 3.913-5.74c0-.176-.005-.35-.015-.521Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M4.957 5.738h1.565v1.044h1.566V5.738h1.565v1.044h1.565V5.738h1.565v1.044h1.565V5.738h1.566v1.044h1.565V5.738h1.565v1.044h3.766A12 12 0 0 0 12-.001 12 12 0 0 0 1.192 6.782h3.766V5.738Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M19.044 17.217v1.044H17.48v-1.044h-1.565v1.044h-1.565v-1.044h-1.566v1.044h-1.565v-1.044H9.653v1.044H8.088v-1.044H6.522v1.044H4.957v-1.044H1.191A12 12 0 0 0 12.001 24a12 12 0 0 0 10.809-6.783h-3.766Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIr;